import { useState, useEffect } from 'react';
import { auth, db } from '../firebaseconfig';
import { doc, getDoc } from 'firebase/firestore';

const useUser = () => {
  const [users, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        const userDoc = await getDoc(doc(db, 'users', authUser.uid));
        if (userDoc.exists()) {
          setUser(userDoc.data());
        }
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return users;
};

export default useUser;
